<div class="flex flex-col flex-1 min-h-0 w-full">
  <div class="flex-1 min-h-0 w-full overflow-auto bg-gray-100 rounded-md">
    <div class="p-4">
      <div class="text-center mb-4">
        <h2 class="text-xl font-bold text-orange-600 mb-2">Ajuda - Atalhos do PDV</h2>
      </div>

      <div class="grid grid-cols-2 gap-2 mb-4">
        <div 
          *ngFor="let item of helpItems" 
          class="flex items-start gap-2 p-2 bg-white rounded-lg border border-gray-200 hover:bg-orange-50 transition-colors">
          <div class="flex-shrink-0">
            <span class="inline-block px-2 py-1 bg-orange-600 text-white font-mono font-bold rounded text-xs">
              {{ item.key }}
            </span>
          </div>
          <div class="flex-1 min-w-0">
            <p class="text-gray-700 text-xs">{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
